export default "__VITE_ASSET__BhIXshkY__"